import { ButtonPropsSizeType, ButtonText } from '../Button';
import { cn } from '../cn';
import { buttonText } from '../common';

type SelectDropdownNoResultsProps = {
  size?: ButtonPropsSizeType;
};
export default function SelectDropdownNoResults({ size }: SelectDropdownNoResultsProps) {
  return (
    <div className="flex shrink-0 grow items-center truncate">
      <ButtonText size={size} className={cn(buttonText(size))}>
        No results
      </ButtonText>
    </div>
  );
}
